/** Matches {@code HireHealthSurveyPdfTextSplit.DEFAULT_BOX_MAX_CHARS} on the backend. */
export const HIRE_HEALTH_TEXT_BOX_MAX_CHARS = 42;

export const HIRE_HEALTH_TEXT_TWO_BOX_MAX_CHARS = HIRE_HEALTH_TEXT_BOX_MAX_CHARS * 2;

/** Max characters for aftereffects / symptoms free-text answers in chat. */
export const HIRE_HEALTH_DETAIL_MAX_CHARS = 300;
